import ClienteService from "@/services/ClienteService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const cliente = {
    namespace:true,
    state: {clientes:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListCliente({commit},pageNumber){
            return await ClienteService.getlist(pageNumber).then(
                response=>{    
                    commit('setClientes',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListCliente({commit},search){          
            return await ClienteService.getSearch(search).then (
                response =>{                    
                    commit('setClientes',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setClientes(state,data){
        state.clientes = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.clientes.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};